<template>
    <v-app>
            <router-view :key="$route.path"></router-view>
    </v-app>
</template>

<script>
export default {
    name: "AppDefault",

    components: {},

    data: () => ({
        //
    }),
};
</script>

<style>
</style>